/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'auth-settings';

export const authMappingProfileModalBreadcrumbTitle = `${prefix}.authMappingProfileModalBreadcrumbTitle`;
export const authMappingRuleModalBreadcrumbTitle = `${prefix}.authMappingRuleModalBreadcrumbTitle`;

export const ENGLISH = {
    [authMappingProfileModalBreadcrumbTitle]: 'Mapping Profile',
    [authMappingRuleModalBreadcrumbTitle]: 'Mapping Rule',
};
